import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { Box, Heading, Image, Text } from "@chakra-ui/react";
import Breadcrumb from "../../components/common/Breadcrumb";
import { Link, useNavigate, useParams } from "react-router-dom";
import HeroAsiaCup2025Highlights from "./HeroAsiaHockeyCup2025.json";
import BWKLE2 from "./BWKLE2Highlights.json";
import BiharDiwas from "./BiharDiwas.json";
import SportsConclave from "./SportsConclave.json";
import SubJunMenHock2026 from "./sub-jun-men-hock.json";
import MedalLaoNaukriPao2026 from "./medal-lao-naukri-pao-2026.json";
import SummerCamp2026 from "./summer-camp-2026.json";
import Esports2026 from "./esports-2026.json";
import SenNatRugby7s2026 from "./sen-nat-rugby-7s-2026.json";
import Fide2026 from "./fide-2026.json";

const KSSGalleryImg = () => {
  const routeParams = useParams();
  const navigate = useNavigate();
  console.log("routeParams....", routeParams);

  const [ActiveArray, setActiveArray] = useState([]);

  const Fencing = Array.from({ length: 11 }, (_, i) => ({
    img: `/img/Fencing/fencing-${i + 1}.png`,
  }));
  // fix fencing images
  const KIYG25Gymnastics = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/gymnastics/gy-${i + 1}.jpg`,
  }));
  const KIYG25Boxing = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/boxing/box-${i + 1}.jpg`,
  }));
  const KIYG25Badminton = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/badminton/ba-${i + 1}.jpg`,
  }));
  const KIYG25Yoga = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/yogasana/yog-${i + 1}.jpg`,
  }));
  const KIYG25Tennis = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/tennis/ten-${i + 1}.jpg`,
  }));
  const KIYG25Basketball = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/basketball/bas-${i + 1}.jpg`,
  }));
  const KIYG25Wrestling = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/wrestling/wr-${i + 1}.jpg`,
  }));
  const KIYG25Athletics = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/athletics/h-${i + 1}.jpg`,
  }));
  const KIYG25Fencing = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/fencing/f-${i + 1}.jpg`,
  }));
  const KIYG25Weightlifting = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/weightlifting/w-${i + 1}.jpg`,
  }));
  const KIYG25Archery = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/archery/a-${i + 1}.jpg`,
  }));
  const KIYG25Kabaddi = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/kabaddi/k-${i + 1}.jpg`,
  }));
  const KIYG25RoadCycling = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/cycling-road/cr-${i + 1}.jpg`,
  }));
  const KIYG25Football = Array.from({ length: 20 }, (_, i) => ({
    img: `/img/kiyg25-highlights/football/f-${i + 1}.jpg`,
  }));
  const KIYG25Gatka = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/gatka/g-${i + 1}.jpg`,
  }));
  const KIYG25Hockey = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/hockey/h-${i + 1}.jpg`,
  }));
  const KIYG25IndoorCycling = Array.from({ length: 5 }, (_, i) => ({
    img: `/img/kiyg25-highlights/indoor-cycling/ic-${i + 1}.jpg`,
  }));
  const KIYG25Judo = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/judo/j-${i + 1}.jpg`,
  }));
  const KIYG25Kalarippayattu = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/kalarippayattu/k-${i + 1}.jpg`,
  }));
  const KIYG25KhoKho = Array.from({ length: 20 }, (_, i) => ({
    img: `/img/kiyg25-highlights/kho-kho/kh-${i + 1}.jpg`,
  }));
  const KIYG25Mallakhamb = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/mallakhamb/m-${i + 1}.jpg`,
  }));
  const KIYG25Rugby = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/rugby/r-${i + 1}.jpg`,
  }));
  const KIYG25Sepaktakraw = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/sepaktakraw/s-${i + 1}.jpg`,
  }));
  const KIYG25Shooting = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/shooting/sh-${i + 1}.jpg`,
  }));
  const KIYG25Swimming = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/swimming/s-${i + 1}.jpg`,
  }));
  const KIYG25TableTennis = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/table-tennis/tt-${i + 1}.jpg`,
  }));
  const KIYG25ThangTa = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/thangta/th-${i + 1}.jpg`,
  }));
  const KIYG25Volleyball = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/kiyg25-highlights/volleyball/v-${i + 1}.jpg`,
  }));
  const KIYG25Opening = Array.from({ length: 11 }, (_, i) => ({
    img: `/img/kiyg25-highlights/opening-ceremony/o-${i + 1}.jpg`,
  }));
  const KIYG25Closing = Array.from({ length: 7 }, (_, i) => ({
    img: `/img/kiyg25-highlights/closing-ceremony/c-${i + 1}.jpg`,
  }));
  const KIYG25Launching = Array.from({ length: 17 }, (_, i) => ({
    img: `/img/kiyg25-highlights/launching-ceremony/u-${i + 1}.jpg`,
  }));
  const IYD25 = Array.from({ length: 15 }, (_, i) => ({
    img: `/img/yoga-day-2025/y-${i + 1}.jpg`,
  }));
  const AsiaRugbyU207s = Array.from({ length: 20 }, (_, i) => ({
    img: `/img/AsiaRugbyU207s/highlights/${i + 1}.jpg`,
  }));
  const HeroAsiaMensHockeyCup2025 = HeroAsiaCup2025Highlights.map((link) => ({
    img: link,
  }));
  const BWKLE2Highlights = BWKLE2.map((link) => ({
    img: link,
  }));
  const BiharDiwas2026 = BiharDiwas.map((link) => ({
    img: link,
  }));
  const SportsConclave2026 = SportsConclave.map((link) => ({
    img: link,
  }));
  const SubJunMenHock = SubJunMenHock2026.map((link) => ({
    img: link,
  }));
  const MedalLaoNaukriPao = MedalLaoNaukriPao2026.map((link) => ({
    img: link,
  }));
  const SummerCamp = SummerCamp2026.map((link) => ({ img: link }));
  const Esports = Esports2026.map((link) => ({ img: link }));
  const SenNatRugby7s = SenNatRugby7s2026.map((link) => ({ img: link }));
  const Fide = Fide2026.map((link) => ({ img: link }));
  const KIYG25Highlights = [
    {
      img: "/img/kiyg25-highlights/launching-ceremony/u-1.jpg",
      text: "Launching Ceremony",
      name: "kiyg25-launching-ceremony",
    },
    {
      img: "/img/kiyg25-highlights/opening-ceremony/o-1.jpg",
      text: "Opening Ceremony",
      name: "kiyg25-opening-ceremony",
    },
    {
      img: "/img/kiyg25-highlights/weightlifting/w-1.jpg",
      text: "Weightlifting",
      name: "kiyg25-weightlifting",
    },
    {
      img: "/img/kiyg25-highlights/fencing/f-1.jpg",
      text: "Fencing",
      name: "kiyg25-fencing",
    },
    {
      img: "/img/kiyg25-highlights/athletics/h-1.jpg",
      text: "Athletics",
      name: "kiyg25-athletics",
    },
    {
      img: "/img/kiyg25-highlights/tennis/ten-1.jpg",
      text: "Tennis",
      name: "kiyg25-tennis",
    },
    {
      img: "/img/kiyg25-highlights/basketball/bas-1.jpg",
      text: "Basketball",
      name: "kiyg25-basketball",
    },
    {
      img: "/img/kiyg25-highlights/wrestling/wr-1.jpg",
      text: "Wrestling",
      name: "kiyg25-wrestling",
    },
    {
      img: "/img/kiyg25-highlights/gymnastics/gy-1.jpg",
      text: "Gymnastics",
      name: "kiyg25-gymnastics",
    },
    {
      img: "/img/kiyg25-highlights/boxing/box-1.jpg",
      text: "Boxing",
      name: "kiyg25-boxing",
    },
    {
      img: "/img/kiyg25-highlights/yogasana/yog-1.jpg",
      text: "Yogasana",
      name: "kiyg25-yogasana",
    },
    {
      img: "/img/kiyg25-highlights/badminton/ba-1.jpg",
      text: "Badminton",
      name: "kiyg25-badminton",
    },
    {
      img: "/img/kiyg25-highlights/archery/a-1.jpg",
      text: "Archery",
      name: "kiyg25-archery",
    },
    {
      img: "/img/kiyg25-highlights/kabaddi/k-1.jpg",
      text: "Kabaddi",
      name: "kiyg25-kabaddi",
    },
    {
      img: "/img/kiyg25-highlights/volleyball/v-1.jpg",
      text: "Volleyball",
      name: "kiyg25-volleyball",
    },
    {
      img: "/img/kiyg25-highlights/thangta/th-1.jpg",
      text: "Thang Ta",
      name: "kiyg25-thangta",
    },
    {
      img: "/img/kiyg25-highlights/table-tennis/tt-1.jpg",
      text: "Table Tennis",
      name: "kiyg25-table-tennis",
    },
    {
      img: "/img/kiyg25-highlights/swimming/s-1.jpg",
      text: "Swimming",
      name: "kiyg25-swimming",
    },
    {
      img: "/img/kiyg25-highlights/shooting/sh-1.jpg",
      text: "Shooting",
      name: "kiyg25-shooting",
    },
    {
      img: "/img/kiyg25-highlights/sepaktakraw/s-1.jpg",
      text: "Sepaktakraw",
      name: "kiyg25-sepaktakraw",
    },
    {
      img: "/img/kiyg25-highlights/rugby/r-1.jpg",
      text: "Rugby 7's",
      name: "kiyg25-rugby",
    },
    {
      img: "/img/kiyg25-highlights/mallakhamb/m-1.jpg",
      text: "Mallakhamb",
      name: "kiyg25-mallakhamb",
    },
    {
      img: "/img/kiyg25-highlights/kho-kho/kh-1.jpg",
      text: "Kho-Kho",
      name: "kiyg25-khokho",
    },
    {
      img: "/img/kiyg25-highlights/kalarippayattu/k-1.jpg",
      text: "Kalarippayattu",
      name: "kiyg25-kalarippayattu",
    },
    {
      img: "/img/kiyg25-highlights/judo/j-1.jpg",
      text: "Judo",
      name: "kiyg25-judo",
    },
    {
      img: "/img/kiyg25-highlights/indoor-cycling/ic-1.jpg",
      text: "Cycling (Indoor)",
      name: "kiyg25-indoor-cycling",
    },
    {
      img: "/img/kiyg25-highlights/hockey/h-1.jpg",
      text: "Hockey",
      name: "kiyg25-hockey",
    },
    {
      img: "/img/kiyg25-highlights/gatka/g-1.jpg",
      text: "Gatka",
      name: "kiyg25-gatka",
    },
    {
      img: "/img/kiyg25-highlights/football/f-1.jpg",
      text: "Football",
      name: "kiyg25-football",
    },
    {
      img: "/img/kiyg25-highlights/cycling-road/cr-1.jpg",
      text: "Cycling (Road)",
      name: "kiyg25-road-cycling",
    },
    {
      img: "/img/kiyg25-highlights/closing-ceremony/c-1.jpg",
      text: "Closing Ceremony",
      name: "kiyg25-closing-ceremony",
    },
  ];
  const KIYG25Evening = Array.from({ length: 5 }, (_, i) => ({
    img: `/img/kiyg25-evening/launch-${i + 1}.jpg`,
  }));
  const KIYG25Morning = Array.from({ length: 5 }, (_, i) => ({
    img: `/img/kiyg25-morning/launch-${i + 1}.jpg`,
  }));
  const Sepaktakraw = Array.from({ length: 8 }, (_, i) => ({
    img: `/img/istaf-wc-2025/sepaktakraw-${i + 1}.jpg`,
  }));
  const eSports = Array.from({ length: 14 }, (_, i) => ({
    img: `/img/Esports/IMG-20250204-WA${String(9 + i).padStart(4, "0")}.jpg`,
  }));
  const Rugby = Array.from({ length: 18 }, (_, i) => ({
    img: `/img/68thNationalSchoolGameRugby/IMG-20250203-WA${String(
      37 + i
    ).padStart(4, "0")}.jpg`,
  }));
  const Cycling = [
    {
      img: "/img/68thNationalSchoolGamesCycling(Road)/IMG-20250203-WA0022.jpg",
    },
    {
      img: "/img/68thNationalSchoolGamesCycling(Road)/IMG-20250203-WA0023.jpg",
    },
    {
      img: "/img/68thNationalSchoolGamesCycling(Road)/IMG-20250203-WA0024.jpg",
    },
    {
      img: "/img/68thNationalSchoolGamesCycling(Road)/IMG-20250203-WA0025.jpg",
    },
    {
      img: "/img/68thNationalSchoolGamesCycling(Road)/IMG-20250203-WA0026.jpg",
    },
    {
      img: "/img/68thNationalSchoolGamesCycling(Road)/IMG-20250203-WA0027.jpg",
    },
    {
      img: "/img/68thNationalSchoolGamesCycling(Road)/IMG-20250203-WA0028.jpg",
    },
    {
      img: "/img/68thNationalSchoolGamesCycling(Road)/IMG-20250203-WA0029.jpg",
    },
    {
      img: "/img/68thNationalSchoolGamesCycling(Road)/IMG-20250203-WA0030.jpg",
    },
    {
      img: "/img/68thNationalSchoolGamesCycling(Road)/IMG-20250203-WA0031.jpg",
    },
    {
      img: "/img/68thNationalSchoolGamesCycling(Road)/IMG-20250203-WA0032.jpg",
    },
    {
      img: "/img/68thNationalSchoolGamesCycling(Road)/IMG-20250203-WA0033.jpg",
    },
  ];

  const KSS2023atGyanBhawan = [
    { img: "/img/KSS-2023/DSC_3807.jpg" },
    { img: "/img/KSS-2023/DSC_3808.jpg" },
    { img: "/img/KSS-2023/DSC_3815.jpg" },
    { img: "/img/KSS-2023/DSC_3832.jpg" },
    { img: "/img/KSS-2023/DSC_3505.jpg" },
    { img: "/img/KSS-2023/DSC_3511.jpg" },
    { img: "/img/KSS-2023/DSC_3513.jpg" },
    { img: "/img/KSS-2023/DSC_3516.jpg" },
    { img: "/img/KSS-2023/DSC_3517.jpg" },
    { img: "/img/KSS-2023/DSC_3518.jpg" },
    { img: "/img/KSS-2023/DSC_3527.jpg" },
    { img: "/img/KSS-2023/DSC_3528.jpg" },
    { img: "/img/KSS-2023/DSC_3530.jpg" },
    { img: "/img/KSS-2023/DSC_3537.jpg" },
    { img: "/img/KSS-2023/DSC_3540.jpg" },
    { img: "/img/KSS-2023/DSC_3542.jpg" },
    { img: "/img/KSS-2023/DSC_3548.jpg" },
    { img: "/img/KSS-2023/DSC_3552.jpg" },
    { img: "/img/KSS-2023/DSC_3561.jpg" },
    { img: "/img/KSS-2023/DSC_3562.jpg" },
    { img: "/img/KSS-2023/DSC_3564.jpg" },
    { img: "/img/KSS-2023/DSC_3565.jpg" },
    { img: "/img/KSS-2023/DSC_3567.jpg" },
    { img: "/img/KSS-2023/DSC_3572.jpg" },
    { img: "/img/KSS-2023/DSC_3576.jpg" },
    { img: "/img/KSS-2023/DSC_3626.jpg" },
    { img: "/img/KSS-2023/DSC_3646.jpg" },
    { img: "/img/KSS-2023/DSC_3653.jpg" },
    { img: "/img/KSS-2023/DSC_3657.jpg" },
    { img: "/img/KSS-2023/DSC_3661.jpg" },
    { img: "/img/KSS-2023/DSC_3664.jpg" },
    { img: "/img/KSS-2023/DSC_3674.jpg" },
  ];

  const BiharStateEsportsOpenChampionship = [
    { img: "/img/1stBiharSEOc/1stbSEoC.jpg" },
    { img: "/img/1stBiharSEOc/1stbSEoC2.jpg" },
    { img: "/img/1stBiharSEOc/1stbSEoC3.jpg" },
    { img: "/img/1stBiharSEOc/1stbSEoC4.jpg" },
    { img: "/img/1stBiharSEOc/1stbSEoC5.jpg" },
    { img: "/img/1stBiharSEOc/1stbSEoC6.jpg" },
    { img: "/img/1stBiharSEOc/1stbSEoC7.jpg" },
    { img: "/img/1stBiharSEOc/1stbSEoC8.jpg" },
    { img: "/img/1stBiharSEOc/1stbSEoC9.jpg" },
  ];

  const NationalSchoolChessChampionship2024 = [
    { img: "/img/12thNS-CHES24/P1383941.jpg" },
    { img: "/img/12thNS-CHES24/P1383956.jpg" },
    { img: "/img/12thNS-CHES24/P1383986.jpg" },
    { img: "/img/12thNS-CHES24/P1383996.jpg" },
    { img: "/img/12thNS-CHES24/P1384018.jpg" },
    { img: "/img/12thNS-CHES24/P1384156.jpg" },
    { img: "/img/12thNS-CHES24/P1384159.jpg" },
    { img: "/img/12thNS-CHES24/P1384163.jpg" },
    { img: "/img/12thNS-CHES24/P1384180.jpg" },
    { img: "/img/12thNS-CHES24/P1384666.jpg" },
    { img: "/img/12thNS-CHES24/P1384732.jpg" },
    { img: "/img/12thNS-CHES24/P1384873.jpg" },
  ];

  const BiharSchoolChessatBSSA = [
    { img: "/img/Bihar-School-Chess/DSC_1538.jpg" },
    { img: "/img/Bihar-School-Chess/DSC_1543.jpg" },
    { img: "/img/Bihar-School-Chess/DSC_1566.jpg" },
    { img: "/img/Bihar-School-Chess/DSC_1576.jpg" },
    { img: "/img/Bihar-School-Chess/DSC_1565.jpg" },
    { img: "/img/Bihar-School-Chess/DSC_1652.jpg" },
    { img: "/img/Bihar-School-Chess/DSC_1657.jpg" },
    { img: "/img/Bihar-School-Chess/DSC_1658.jpg" },
  ];
  const BiharWomenKabaddiLeague = [
    { img: "/img/Bihar-Women-Kabaddi-League/JBN00221.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN00222.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN00227.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN00259.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN00481.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN00502.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN00504.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN00506.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN00512.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN00517.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN00808.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN00809.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN00815.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN05753.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN05754.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN05857.jpg" },
    { img: "/img/Bihar-Women-Kabaddi-League/JBN05874.jpg" },
  ];
  const Conclave2 = [
    { img: "/img/Conclave2.0/DSC_8220.jpg" },
    { img: "/img/Conclave2.0/DSC_8225.jpg" },
    { img: "/img/Conclave2.0/DSC_8291.jpg" },
    { img: "/img/Conclave2.0/DSC_8323.jpg" },
    { img: "/img/Conclave2.0/DSC_8345.jpg" },
    { img: "/img/Conclave2.0/DSC_8348.jpg" },
    { img: "/img/Conclave2.0/DSC_8352.jpg" },
    { img: "/img/Conclave2.0/DSC_8355.jpg" },

    { img: "/img/Conclave2.0/DSC_8373.jpg" },
    { img: "/img/Conclave2.0/DSC_8374.jpg" },
    { img: "/img/Conclave2.0/DSC_8220.jpg" },
    { img: "/img/Conclave2.0/DSC_8380.jpg" },
    { img: "/img/Conclave2.0/DSC_8385.jpg" },
    { img: "/img/Conclave2.0/DSC_8390.jpg" },
    { img: "/img/Conclave2.0/DSC_8408.jpg" },
    { img: "/img/Conclave2.0/DSC_8414.jpg" },
    { img: "/img/Conclave2.0/DSC_8436.jpg" },
    { img: "/img/Conclave2.0/DSC_8437.jpg" },
    { img: "/img/Conclave2.0/DSC_8440.jpg" },
    { img: "/img/Conclave2.0/DSC_8442.jpg" },

    { img: "/img/Conclave2.0/DSC_8445.jpg" },
    { img: "/img/Conclave2.0/DSC_8500.jpg" },
    { img: "/img/Conclave2.0/DSC_8524.jpg" },
    { img: "/img/Conclave2.0/DSC_8577.jpg" },
    { img: "/img/Conclave2.0/DSC_8583.jpg" },
    { img: "/img/Conclave2.0/DSC_8599.jpg" },
    { img: "/img/Conclave2.0/DSC_8622.jpg" },
    { img: "/img/Conclave2.0/DSC_8652.jpg" },
    { img: "/img/Conclave2.0/DSC_8654.jpg" },
    { img: "/img/Conclave2.0/DSC_8659.jpg" },
    { img: "/img/Conclave2.0/DSC_8808.jpg" },
    { img: "/img/Conclave2.0/DSC_8854.jpg" },
    { img: "/img/Conclave2.0/DSC_8213.jpg" },
    { img: "/img/Conclave2.0/DSC_8659.jpg" },
    { img: "/img/Conclave2.0/DSC_8224.jpg" },
    { img: "/img/Conclave2.0/DSC_8854.jpg" },
  ];
  const DashrathManjhi = [
    { img: "/img/DashrathManjhi/DSC_6890.jpg" },
    { img: "/img/DashrathManjhi/DSC_6911.jpg" },
    { img: "/img/DashrathManjhi/DSC_6915.jpg" },
    { img: "/img/DashrathManjhi/DSC_6924.jpg" },
    { img: "/img/DashrathManjhi/DSC_6968.jpg" },
    { img: "/img/DashrathManjhi/DSC_6676.jpg" },
    { img: "/img/DashrathManjhi/DSC_6679.jpg" },
    { img: "/img/DashrathManjhi/DSC_6681.jpg" },
    { img: "/img/DashrathManjhi/DSC_6685.jpg" },
    { img: "/img/DashrathManjhi/DSC_6686.jpg" },
    { img: "/img/DashrathManjhi/DSC_6692.jpg" },
    { img: "/img/DashrathManjhi/DSC_6693.jpg" },
    { img: "/img/DashrathManjhi/DSC_6711.jpg" },
    { img: "/img/DashrathManjhi/DSC_6712.jpg" },
    { img: "/img/DashrathManjhi/DSC_6719.jpg" },
    { img: "/img/DashrathManjhi/DSC_6765.jpg" },
    { img: "/img/DashrathManjhi/DSC_6766.jpg" },
    { img: "/img/DashrathManjhi/DSC_6803.jpg" },
    { img: "/img/DashrathManjhi/DSC_6845.jpg" },
    { img: "/img/DashrathManjhi/DSC_6850.jpg" },
    { img: "/img/DashrathManjhi/DSC_6858.jpg" },
    { img: "/img/DashrathManjhi/DSC_6878.jpg" },
    { img: "/img/DashrathManjhi/DSC_6886.jpg" },
  ];
  const BiharVolleyballLeague2024 = [
    { img: "/img/BiharVolleyballLeague2024/DSC00350.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC00358.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC00359.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC00360.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC00361.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC00363.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC00372.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC00373.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC00383.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02436.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02445.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02446.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02447.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02457.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02461.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02467.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02469.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02473.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02477.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02478.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02481.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02521.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02524.jpg" },
    { img: "/img/BiharVolleyballLeague2024/DSC02527.jpg" },
  ];

  const BiharWomensAsianChampionsTrophyRajgir2024 = [
    { img: "/img/BWACTRajgir2024/ADIM19600.JPG" },
    { img: "/img/BWACTRajgir2024/ADIM19649.JPG" },
    { img: "/img/BWACTRajgir2024/ADIM19666.JPG" },
    { img: "/img/BWACTRajgir2024/ADIM21686.JPG" },
    { img: "/img/BWACTRajgir2024/ADIM21988.jpg" },
    { img: "/img/BWACTRajgir2024/ADIM36811.jpg" },
    { img: "/img/BWACTRajgir2024/ADIM24179.jpg" },
    { img: "/img/BWACTRajgir2024/ADIM24210.jpg" },
    { img: "/img/BWACTRajgir2024/ADIM25484.jpg" },
    { img: "/img/BWACTRajgir2024/ADIM27120.JPG" },
    { img: "/img/BWACTRajgir2024/ADIM28005.JPG" },
    { img: "/img/BWACTRajgir2024/ADIM28052.JPG" },
    { img: "/img/BWACTRajgir2024/ADIM28955.jpg" },
    { img: "/img/BWACTRajgir2024/ADIM30813.JPG" },
    { img: "/img/BWACTRajgir2024/ADIM30852.jpg" },

    { img: "/img/BWACTRajgir2024/ADIM35883.jpg" },
    { img: "/img/BWACTRajgir2024/ADIM36811.jpg" },
    { img: "/img/BWACTRajgir2024/ADIM44052.jpg" },
    { img: "/img/BWACTRajgir2024/ADIM44391.jpg" },
    { img: "/img/BWACTRajgir2024/ADIM45608.jpg" },
    { img: "/img/BWACTRajgir2024/ADIM19600.JPG" },
    { img: "/img/BWACTRajgir2024/ADIM45653.jpg" },
  ];

  useEffect(() => {
    switch (routeParams.id) {
      case "fide-2026":
        setActiveArray(Fide);
        break;
      case "medal-lao-naukri-pao-2026":
        setActiveArray(MedalLaoNaukriPao);
        break;
      case "bssa-summer-camp-2026":
        setActiveArray(SummerCamp);
        break;
      case "esports-2026":
        setActiveArray(Esports);
        break;
      case "senior-national-rugby-7s-2026":
        setActiveArray(SenNatRugby7s);
        break;
      case "sub-junior-mens-hockey-2026":
        setActiveArray(SubJunMenHock);
        break;
      case "sports-conclave":
        setActiveArray(SportsConclave2026);
        break;
      case "bihar-diwas-2026":
        setActiveArray(BiharDiwas2026);
        break;
      case "bihar-women-kabaddi-league-edition-2":
        setActiveArray(BWKLE2Highlights);
        break;
      case "hero-asia-hockey-cup-2025":
        setActiveArray(HeroAsiaMensHockeyCup2025);
        break;
      case "asia-rugby-u20-7s":
        setActiveArray(AsiaRugbyU207s);
        break;
      case "international-yoga-day-2025":
        setActiveArray(IYD25);
        break;
      case "kiyg25-football":
        setActiveArray(KIYG25Football);
        break;
      case "kiyg25-gatka":
        setActiveArray(KIYG25Gatka);
        break;
      case "kiyg25-hockey":
        setActiveArray(KIYG25Hockey);
        break;
      case "kiyg25-indoor-cycling":
        setActiveArray(KIYG25IndoorCycling);
        break;
      case "kiyg25-judo":
        setActiveArray(KIYG25Judo);
        break;
      case "kiyg25-kalarippayattu":
        setActiveArray(KIYG25Kalarippayattu);
        break;
      case "kiyg25-khokho":
        setActiveArray(KIYG25KhoKho);
        break;
      case "kiyg25-mallakhamb":
        setActiveArray(KIYG25Mallakhamb);
        break;
      case "kiyg25-rugby":
        setActiveArray(KIYG25Rugby);
        break;
      case "kiyg25-sepaktakraw":
        setActiveArray(KIYG25Sepaktakraw);
        break;
      case "kiyg25-shooting":
        setActiveArray(KIYG25Shooting);
        break;
      case "kiyg25-swimming":
        setActiveArray(KIYG25Swimming);
        break;
      case "kiyg25-table-tennis":
        setActiveArray(KIYG25TableTennis);
        break;
      case "kiyg25-thangta":
        setActiveArray(KIYG25ThangTa);
        break;
      case "kiyg25-volleyball":
        setActiveArray(KIYG25Volleyball);
        break;
      case "kiyg25-road-cycling":
        setActiveArray(KIYG25RoadCycling);
        break;
      case "kiyg25-launching-ceremony":
        setActiveArray(KIYG25Launching);
        break;
      case "kiyg25-opening-ceremony":
        setActiveArray(KIYG25Opening);
        break;
      case "kiyg25-closing-ceremony":
        setActiveArray(KIYG25Closing);
        break;
      case "kiyg25-archery":
        setActiveArray(KIYG25Archery);
        break;
      case "kiyg25-kabaddi":
        setActiveArray(KIYG25Kabaddi);
        break;
      case "kiyg25-weightlifting":
        setActiveArray(KIYG25Weightlifting);
        break;
      case "kiyg25-fencing":
        setActiveArray(KIYG25Fencing);
        break;
      case "kiyg25-athletics":
        setActiveArray(KIYG25Athletics);
        break;
      case "kiyg25-wrestling":
        setActiveArray(KIYG25Wrestling);
        break;
      case "kiyg25-basketball":
        setActiveArray(KIYG25Basketball);
        break;
      case "kiyg25-tennis":
        setActiveArray(KIYG25Tennis);
        break;
      case "kiyg25-badminton":
        setActiveArray(KIYG25Badminton);
        break;
      case "kiyg25-boxing":
        setActiveArray(KIYG25Boxing);
        break;
      case "kiyg25-yogasana":
        setActiveArray(KIYG25Yoga);
        break;
      case "kiyg25-gymnastics":
        setActiveArray(KIYG25Gymnastics);
        break;
      case "Khelo-India-2025-Highlights":
        setActiveArray(KIYG25Highlights);
        break;
      case "Khelo-India-2025-Launch-Evening":
        setActiveArray(KIYG25Evening);
        break;
      case "Khelo-India-2025-Launch-Morning":
        setActiveArray(KIYG25Morning);
        break;
      case "ISTAF Sepaktakraw World Cup 2025":
        setActiveArray(Sepaktakraw);
        break;
      case "68 National School Games Fencing":
        setActiveArray(Fencing);
        break;
      case "Bihar State Open Esports Championship 2024":
        setActiveArray(eSports);
        break;
      case "68th National School Game Rugby":
        setActiveArray(Rugby);
        break;
      case "68th National School Games Cycling (Road)":
        setActiveArray(Cycling);
        break;
      case "KSS-2023 at Gyan Bhawan":
        setActiveArray(KSS2023atGyanBhawan);
        break;
      case "1st Bihar State Esports Open Championship":
        setActiveArray(BiharStateEsportsOpenChampionship);
        break;
      case "12th National School Chess Championship- 2024":
        setActiveArray(NationalSchoolChessChampionship2024);
        break;
      case "Bihar School Chess at BSSA":
        setActiveArray(BiharSchoolChessatBSSA);
        break;
      case "Bihar Women Kabaddi League":
        setActiveArray(BiharWomenKabaddiLeague);
        break;
      case "Conclave 2.0":
        setActiveArray(Conclave2);
        break;
      case "Dashrath Manjhi":
        setActiveArray(DashrathManjhi);
        break;
      case "Bihar Volleyball League 2024":
        setActiveArray(BiharVolleyballLeague2024);
        break;
      case "Bihar Women's Asian Champions Trophy Rajgir 2024":
        setActiveArray(BiharWomensAsianChampionsTrophyRajgir2024);
        break;
      default:
        setActiveArray([]);
        break;
    }
  }, [routeParams.id]);
  // Redirect to GalleryPage if the page is refreshed
  // useEffect(() => {
  //   if (performance.getEntriesByType("navigation")[0].type === "reload") {
  //     navigate("/"); // Replace with your desired route
  //   }
  // }, [navigate]);

  return (
    <div>
      <Breadcrumb
        pageName="Gallery"
        pageTitle="gallery"
        id="#gallery"
        img_url="../../img/Gallery-desktop.jpg"
        mobile_banner="../../img/Gallery-mobile.jpg"
      />
      <Heading p={5} fontSize="50px">
        Photos
      </Heading>
      <div
        style={{
          height: "4px",
          width: "100%",
          backgroundColor: "rgb(8, 44, 44)",
          paddingBottom: "13px",
        }}
      ></div>
      <div className="container">
        <Row className="justify-content-center">
          {ActiveArray.map((item, index) => (
            <Col
              key={index}
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="mb-4 "
              style={{ marginTop: "15px" }}
            >
              <div
                className="d-flex align-items-center justify-content-center pb-5"
                style={{ height: "100%", marginBottom: "10px" }}
              >
                <Link
                  to={
                    item?.name
                      ? `/GalleryCategoryWise/Events/${item.name}`
                      : "#"
                  }
                  _hover={{ textDecoration: "none" }}
                >
                  <Box
                    position="relative"
                    width="100%"
                    paddingBottom="75%" // Creates a 4:3 aspect ratio
                    overflow="hidden"
                    backgroundColor="#f0f0f0" // Optional: Add a background color for empty space
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Image
                      src={item.img}
                      alt={item.name}
                      className="aspect-ratio-item"
                      position="absolute"
                      top="0"
                      left="0"
                      width="100%"
                      height="100%"
                      objectFit="fill"
                      transition="transform 0.5s easle"
                      _hover={{ transform: "scale(1.2)" }}
                    />
                  </Box>
                  {item?.text && (
                    <Text
                      textAlign="center"
                      marginTop="10px"
                      style={{ fontSize: "20px", fontWeight: "700" }}
                    >
                      {item.text}
                    </Text>
                  )}
                </Link>
                {/* <div
                  style={{
                    position: 'relative',
                    width: '100%',
                    paddingBottom: '56.25%', // This is for a 16:9 aspect ratio. Adjust as needed.
                    overflow: 'hidden',
                  }}
                >
                  <img
                    src={item.img}
                    alt={item.name}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                </div> */}
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default KSSGalleryImg;
